import React from 'react';
import useEnqueueTrigger from '../Contexts/SessionConnectionContextProvider/Hooks/useEnqueueTrigger';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useHandleSessionActivityTrigger() {
  const enqueueTrigger = useEnqueueTrigger();
  const { sendJsonMessage, lastJsonMessage } = useAudioServerCommunication();
  React.useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === 'sessionActivityTrigger') {
      const subKey = lastJsonMessage.activate ? 'activate' : 'deactivate';
      enqueueTrigger(
        'activityChange',
        subKey,
        () => {
          sendJsonMessage({
            type: 'confirm-session-activity-change',
            date: Date.now() * 1e6,
            activate: lastJsonMessage.activate,
            detection: lastJsonMessage.detection,
          });
        },
      );
    }
  }, [lastJsonMessage]);
}
